import $ from 'jquery';

export default function pointshopModule() {
  const summaryElement = $('.shopping-cart-total');
  if (summaryElement.length) {
    return import(/* webpackChunkName: "pointshopSummary" */ '../pointshopSummary')
      .then(({ default: PointshopSummary }) => {
        const pointshopSummary = new PointshopSummary();
        return pointshopSummary;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
